import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpAccountsBatchPage } from '@/features/pcmp/pages/PcmpAccountsBatchPage';
import { pcmpAccountsBatchSearchSchema } from '@/features/pcmp/types/pcmpAccounts.types';

export const Route = createFileRoute('/_auth/pcmp/accounts/batches/$batchNo/')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  validateSearch: pcmpAccountsBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Accounts Batch">
      <Suspense fallback={<PageLoader />}>
        <PcmpAccountsBatchPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
